export function scrollSnapMenu() {
	const menus = document.querySelectorAll('[data-scroll-snap-menu]')

	menus.forEach(menu => {
		const items = menu.querySelectorAll('[data-scroll-snap-menu-item]')
		if (!items.length) return

		items.forEach(item => {
			item.addEventListener('click', () => {
				scrollToItem(menu, item)
			})
		})

		const activeItem = menu.querySelector('.active')
		if (activeItem) {
			scrollToItem(menu, activeItem)
		}
	})
}

function scrollToItem(menu, item) {
	const itemRect = item.getBoundingClientRect()
	const menuRect = menu.getBoundingClientRect()
	const styles = window.getComputedStyle(menu)
	const paddingLeft = parseInt(styles.paddingLeft, 10) || 0
	const offset = itemRect.left - menuRect.left - paddingLeft
	menu.scrollLeft += offset
}
